import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import { useState } from 'react';

const ChanceFailModal = ({
  visible,
  title,
  description,
  confirmText = '확인',
  cancelText = '취소',
  onConfirm,
  onCancle,
}) => {
  const [textValue, setTextValue] = useState('');

  const handleConfirm = () => {
    if (textValue === null || textValue === '') {
      alert('수주실패 사유를 입력하세요');

      return;
    }

    onConfirm(textValue);
    setTextValue('');
  };

  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      open={visible}
      onClose={onCancle}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <Typography variant="subtitle2" component="div">
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          <Typography
            sx={{ whiteSpace: 'pre-line' }}
            variant="body2"
            component="div"
          >
            {description}
          </Typography>
          <TextField
            autoFocus
            margin="dense"
            label="실패 사유"
            fullWidth
            required
            multiline
            maxRows={4}
            value={textValue}
            onChange={(e) => setTextValue(e.target.value)}
          />
        </Stack>
      </DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Button variant="outlined" onClick={onCancle} autoFocus>
          {cancelText}
        </Button>
        <Button variant="outlined" color="error" onClick={handleConfirm}>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChanceFailModal;
